import React, { memo } from 'react';
import { TileViewProps } from 'business/models/CustomModels';
import TileViewNodes from './TileViewNodes';
import './TileView.scss';
import { useRightClick } from 'components/rightClick/rightClickProvider';
import ETreeNodeTypes from 'enums/ETreeNodeTypes';

const isEditableContextMenuTarget = (target: EventTarget | null): boolean => {
  if (!(target instanceof HTMLElement)) {
    return false;
  }
  return !!target.closest(
    'input, textarea, select, [contenteditable="true"], .detail-view-table thead',
  );
};

function TileView(props: TileViewProps) {
  const {
    nodes,
    nodeClickHandler,
    viewNodes,
    treeControlState,
    onClickNodeChildren,
    onDoubleClick,
    refreshNode,
    refreshTreeNodeAfterRename,
    setTreeControlState,
  } = props;

  const { handleRightClick } = useRightClick();
  const onContextMenuHandler = (e: React.MouseEvent) => {
    if (isEditableContextMenuTarget(e.target)) {
      return;
    }

    const isQuickAccess =
      treeControlState.selectedExplorerNode?.type === ETreeNodeTypes.QuickAccess;
    if (!treeControlState.selectedExplorerNode || isQuickAccess) {
      return;
    }

    e.preventDefault();
    e.persist();

    setTreeControlState({
      ...treeControlState,
      selectedNodes: [treeControlState.selectedExplorerNode],
      isContextBackground: true,
    });

    handleRightClick(e);
  };
  function onDeleteCompletion(nodeParentId: number) {
    const parentNode: any = getTreeNodeById(nodes, nodeParentId);
    setTreeControlState({ ...treeControlState, selectedNodes: [parentNode] });
    onDoubleClick(parentNode);
  }
  function getTreeNodeById(nodes, pTreeNodeId) {
    let treeNode;
    for (let i = 0; i < nodes.length; i++) {
      let tempTreeNode = {};
      tempTreeNode = nodes[i];
      if (nodes[i].id === pTreeNodeId) {
        treeNode = tempTreeNode;
        break;
      } else if (nodes[i].children) {
        treeNode = getTreeNodeById(nodes[i].children, pTreeNodeId);
      }
    }
    return treeNode;
  }

  return (
    <>
      <div
        id="tile-view-main-tree-control"
        className="mainTreeControl"
        style={{ overflow: 'hidden' }}
      >
        <div id="tile-view-main" className="h-100" style={{ zIndex: 1 }}>
          <div
            id="tile-view-on-context-menu-handler"
            className="h-100"
            onContextMenu={onContextMenuHandler}
          >
            <TileViewNodes
              node={viewNodes}
              nodeClickHandler={nodeClickHandler}
              selectedNodes={treeControlState.selectedNodes}
              onClickNodeChildren={onClickNodeChildren}
              openDocument={onDoubleClick}
              onDoubleClickHandler={onDoubleClick}
              refreshNode={refreshNode}
              onDeleteCompletion={onDeleteCompletion}
              refreshTreeNodeAfterRename={refreshTreeNodeAfterRename}
              treeControlState={treeControlState}
              setTreeControlState={setTreeControlState}
            />
          </div>
        </div>
      </div>
    </>
  );
}
export default memo(TileView);
